import { useEffect, useState, useRef } from "react";
import { getToken, getUserId,getInizioPeriodo,getFinePeriodo } from "../../../auth";
import funzione_collegamento from "../../../funzioni_server/pacchetti_lez_function.js";
import  differenzaOrario  from "../../../funzioni/differenza_ore";
import "../../../stili/tabelle.css";
import "../../../stili/popup.css";
import "../../../stili/tabs.css"
import convertDate from "../../../funzioni/converti_data";
import { DateTime } from 'luxon';
import nome_id from "../../../funzioni/nome_id.js"
import {convertiIdNoleggio,convertiValuta,convertiCambi,guadagnoEscursione,convertiIdEscursione,convertiIdInventario,materialeDisponibile,analisiMateriale,sovrapposti,ordinaPerData} from "../../../funzioni/funzioni_utili"
import ReactDOM from "react-dom/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faUsers, faPencil, faTrashCan,faCircleInfo,faSpinner,faCheck,faX } from "@fortawesome/free-solid-svg-icons";
import Lottie from "lottie-react";
import animLoading from "../../../assets/loading.json";
import {noleggi_off,utenti_off} from "../../../offline/offline_costanti.js";
/* global $ */
/* global DevExpress */
function EscursioniStorico(){
const inizioP=DateTime.fromISO(getInizioPeriodo()).toFormat("yyyyMMdd")
const fineP=DateTime.fromISO(getFinePeriodo()).plus({days:1}).toFormat("yyyyMMdd")
function handleClick(cellInfo,spese,clienti,utenti,cambi,conti) {
    const content=mostraDettagliEscursione(spese,clienti,utenti,cellInfo.data,cellInfo,cambi,conti)
    $("#infoEscursioni").dxPopup("instance").option( "title",`Dettagli Escursione`);
    $("#infoEscursioni").dxPopup("instance").option("contentTemplate", () => content);
    $("#infoEscursioni").dxPopup("instance").show();
}
 function openContoFormPopup(initialData, aggiunta) {
  const popup = $("#popupContoEdit").dxPopup("instance");

  popup.option("contentTemplate", function() {
    const container = $("<div>");
    container.dxForm({
      formData: initialData,
      labelLocation: "top",
      items: [
         {
      dataField: "data",
      label: { text: "Data" },
      template: function(formItem, itemElement) {
        itemElement.empty();

        // Converto il valore iniziale in Date se è ISO:
        let initialValue = formItem.editorOptions?.value || formItem.component.option("formData").data;
        if (typeof initialValue === "string") {
          initialValue = new Date(initialValue);
        }

        $("<div>").appendTo(itemElement).dxDateBox({
          type: "date",
          displayFormat: "dd/MM/yyyy",
          value: initialValue,
          onValueChanged: function(e) {
             const form = formItem.component; // usa il componente passato
    const fd = form.option("formData");
    fd.data = e.value ? e.value.toISOString().slice(0,10) : null;
    form.option("formData", fd);
          }
        });
      }
    },
          { dataField: "nome" },
        { dataField: "note" },

        {
          itemType: "button",
          horizontalAlignment: "right",
          buttonOptions: {
            text: "Salva",
            type: "success",
            onClick: async function() {
              const form = container.dxForm("instance");
              const data = form.option("formData");
              let richiesta;
              const dati= {billcustomer:data.nome,billdate:convertDate(DateTime.fromISO(data.data)),
                billnotes:data.note}
              if (aggiunta){
                   richiesta = await funzione_collegamento({
                       userid: getUserId(),
                        token: getToken(),
                        logout_on_error: true,
                        valori:dati,
                        azione:'setBillItem'
                   })
                  const instance = $("#val_conto").dxLookup("instance");
                    const datas=instance.option("dataSource");
                    datas.push({id:richiesta.billid,text:data.nome})
                  instance.option("dataSource",datas)
              }
              else {
                  richiesta= await funzione_collegamento({
                       userid: getUserId(),
                        token: getToken(),
                        logout_on_error: true,
                        valori:dati,
                      setId:$("#val_conto").dxLookup("instance").option("value"),
                        azione:'setBillItem'
                   })
                    const instance = $("#val_conto").dxLookup("instance");
                    const datas=instance.option("dataSource");
                    datas.find(x => {
                        if (x.id === instance.option("value")) x.text=data.nome
                    })
                  instance.option("dataSource",datas)
              }
              popup.hide();
            }
          }
        }
      ]
    });
    return container;
  });

  popup.show();
}
function mostraDettagliEscursione(spese,clienti,utenti,escursione,cellInfoEsc,cambi,conti) {
  const allineamento="center"
  let formattedRowsSpese = []
  let formattedRowsClienti = []
  for (let cliente of clienti){
    if (escursione.excursionid===cliente.excursionid){
        let dati={nome:cliente.excursioncustomername,id:cliente.excursioncustomerid,
        costo:cliente.excursioncustomerpaid,pagato:cliente.excursioncustomeradvance,
        telefono:cliente.excursioncustomerphone,residenza:cliente.excursioncustomerresidence,conto:cliente.billid}
        formattedRowsClienti=[...formattedRowsClienti,dati]
    }
  }
  let contatore=0
  for (let spesa of spese){
    if (escursione.excursionid===spesa.excursionid){
        let dati={numero:contatore,categoria:spesa.excursioncostcategory,id:spesa.excursioncostid,
        importo:spesa.excursioncostvalue,valuta:spesa.excursioncostcurrency,
        testa:spesa.excursioncostmultiple,}
        let importoEur=(spesa.excursioncostvalue)
        if (spesa.excursioncostmultiple===1)
        importoEur=importoEur*formattedRowsClienti.length
        if (spesa.excursioncostcurrency===2){
            let data=""
            data=DateTime.fromISO(escursione.data).toFormat("yyyyMMdd")
            const cambio=cambi[data]
            if (spesa.excursioncostmultiple===1)
            importoEur=(spesa.excursioncostvalue/cambio)*formattedRowsClienti.length
            else
            importoEur=(spesa.excursioncostvalue/cambio)
        }
        dati["importoeur"]=importoEur
        contatore+=1
        formattedRowsSpese=[...formattedRowsSpese,dati]
    }
  }
  
  const div = document.createElement("div");
  div.style.padding = "0px";

  const inner = document.createElement("div");
  const innerSpese=document.createElement("div");
  innerSpese.id="gridContainerSpese"
  inner.id = "gridContainerClienti";
  div.appendChild(inner);
  div.appendChild(innerSpese)
  setTimeout(() => {
        
    $("#gridContainerClienti").dxDataGrid({
      dataSource: formattedRowsClienti,
      columns: [
        {
          dataField: "nome",
          caption: "Nome Cliente",
          hidingPriority:4,
          
        },
        { dataField: "costo", alignment:allineamento,caption: "Costo cliente", hidingPriority:3,customizeText: function (e){
          return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}
  },
        { dataField: "pagato", alignment:allineamento,caption: "Pagato",hidingPriority:5,customizeText: function (e){
          return `${e.value.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}
          
        },
        { dataField: "telefono",alignment:allineamento, caption: "Telefono cliente" ,hidingPriority:2,

        
        },
            {
                dataField: "conto",visible:false,
                editCellTemplate: function (cellElement,cellInfo){
            if ($("#val_conto").length===0) {
                $('<div id="val_conto"></div>').appendTo(cellElement)
            }
             let selectBoxData = conti.map(name => ({ id: name.billid, text: name.billcustomer }));

            $("#val_conto").dxLookup({
  dataSource: selectBoxData,
  valueExpr: "id",
  displayExpr: "text",
  value: cellInfo.value,
  searchEnabled: true,
  showClearButton: true,
  placeholder: "Seleziona...",
  onValueChanged: function (e) {
    cellInfo.setValue(e.value);
  },

  // ---> QUI AGGIUNGIAMO I BOTTONI <---
  fieldTemplate: function (selectedItem, container) {
    const valueText = selectedItem ? selectedItem.text : "";

    const wrapper = $("<div>").css({
      display: "flex",
      alignItems: "center",
      width: "100%"
    });

    // Testo del lookup
    $("<span>")
      .text(valueText)
      .css({ flexGrow: 1, overflow: "hidden", textOverflow: "ellipsis" })
      .appendTo(wrapper);

    const instance = $("#val_conto").dxLookup("instance");

    // Funzione helper blocca apertura popup
    const stop = (e) => e.stopPropagation();

    // BTN MODIFICA
    $("<i class='fa-solid fa-pencil' style='cursor:pointer; margin-left:6px;'></i>")
      .on("click", function (e) {
        stop(e);
        const val = instance.option("value");
        if (val) {
          console.log("MODIFICA → id:", val);
          // dentro onClick della matita
const id = instance.option("value");

const conto = conti.find(x => x.billid === id);

openContoFormPopup(
  conto?{nome:conto.billcustomer,data:convertDate(conto.billdate).toISO({includeOffset:false}),
                note:conto.billnotes}: {nome:"",data:convertDate(DateTime.now().toFormat("yyyyMMdd")).toISO({includeOffset:false}),
                note:""},false)
        } else {
          DevExpress.ui.notify("Seleziona un nome per poter modificare!", "error", 1000);
        }
      })
      .appendTo(wrapper);

    // BTN AGGIUNGI
    $("<i class='fa-solid fa-plus' style='cursor:pointer; margin-left:6px;'></i>")
      .on("click", function (e) {
        stop(e);
        console.log("AGGIUNGI → apri popup nuovo");
        openContoFormPopup(
  { nome: "", note:"",data:convertDate(DateTime.now().toFormat("yyyyMMdd")).toISO({includeOffset:false})}, true)
      })
      .appendTo(wrapper);

    // BTN ELIMINA
    $("<i class='fa-solid fa-trash-can' style='cursor:pointer; margin-left:6px;'></i>")
      .on("click", function (e) {
        stop(e);
        const val = instance.option("value");
        if (val) {
          console.log("ELIMINA → id:", val);
          // TUO CODICE QUI
        } else {
          DevExpress.ui.notify("Seleziona un nome per poter eliminare!", "error", 1000);
        }
      })
      .appendTo(wrapper);

    container.empty().append(wrapper);
  }
});

            },
            },
        { dataField: "residenza",alignment:allineamento,caption: "Residenza Cliente" ,hidingPriority:1,

        
        },
        
        {
            type: "buttons",
            minWidth:80,
            buttons: [
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },]}
      ],
      showBorders: true,
      scrolling: { useNative: true },
      rowAlternationEnabled: true,
      columnAutoWidth: true,
      paging: { pageSize: 50 },
      height: "auto",
      width: "auto",
      columnHidingEnabled: true,
      editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            width:"70%",
            height:"auto",
            maxHeight:"90%",
            title: `Modifica cliente`,
            showTitle: true,
          },
          form: {
            items: [
              {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                "nome","costo","pagato","telefono","residenza","conto",
                ],
              },
            ],
          },
      },
      onRowInserting: async function (e) {
            let richiesta=null
            const dati2={billid:e.data.conto?e.data.conto:0,"excursionid":escursione.excursionid,"excursioncustomeradvance": e.data.pagato,"excursioncustomername":e.data.nome,"excursioncustomerpaid":e.data.costo,"excursioncustomerphone":e.data.telefono,}
             richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                valori:dati2,
                azione:'setExcursionCust'})
                $("#loadingOverlay").hide()
                if (richiesta) {
                const message = `${e.data.nome} aggiunto con successo`;

          window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerExcursions',

                },}, "success", 1000);
          const clienti = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getExcursionCusts",})
           formattedRowsClienti=[]
          for (let cliente of clienti){
    if (escursione.excursionid===cliente.excursionid){
        let dati={nome:cliente.excursioncustomername,id:cliente.excursioncustomerid,
        costo:cliente.excursioncustomerpaid,pagato:cliente.excursioncustomeradvance,
        telefono:cliente.excursioncustomerphone,residenza:cliente.excursioncustomerresidence,conto:cliente.billid}
        formattedRowsClienti=[...formattedRowsClienti,dati]
    }
  }
          $("#gridContainerClienti").dxDataGrid("instance").option("dataSource",formattedRowsClienti)
          
          }
          },
      onInitNewRow: function (e) {
        e.data.costo=0;
        e.data.pagato=0;
        },
      onRowPrepared: function (e){
      if (e.rowType === "data" && e.rowElement && e.data) {
            const parseEuro = (val) =>
              parseFloat(String(val).replace("€", "").replace(",", ".").replace(/\s/g, ""));
            const pagato = parseEuro(e.data.pagato);
            const costo = parseEuro(e.data.costo);

            if (!isNaN(pagato) && !isNaN(costo) && Math.abs(pagato - costo) > 0.01) {
              e.rowElement.addClass("row-warning");
              e.rowElement[0].bgColor = "#ffe6e6";
            }
          }
      },
      onRowRemoving: async function (e) {
            const richiesta=  await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                delId:e.data.id,
                azione:'delExcursionCust',
                return_data:false})
            if (richiesta) {
                const message = `${e.data.nome} eliminato con successo`;
                window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerClienti',

                },}, "success", 1000);}
        },
      onRowUpdated: async function (e) {
            const gridElement = $("#gridContainerClienti"); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
            $("#loadingOverlay").show()
            const dati2={billid:e.data.conto?e.data.conto:0,"excursionid":escursione.excursionid,"excursioncustomeradvance": e.data.pagato,"excursioncustomername":e.data.nome,"excursioncustomerpaid":e.data.costo,"excursioncustomerphone":e.data.telefono,}
            const richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:e.data.id,
                valori:dati2,
                azione:'setExcursionCust'})
                $("#loadingOverlay").hide()
                if (richiesta) {
                const message = `${e.data.nome} modificato con successo`;

          window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerClienti',

                },}, "success", 1000);

                }
          },

    });
    $("#gridContainerSpese").dxDataGrid({
      dataSource: formattedRowsSpese,
      columns: [
        {
          dataField: "categoria",
          caption: "Categoria Spesa",
          hidingPriority:4,

        },
        { dataField: "importo", alignment:allineamento,caption: "Importo spesa", hidingPriority:3,calculateDisplayValue: function(rowData) {
    return  `${rowData.importo.toLocaleString("it-IT", { maximumFractionDigits: 2 })} ${convertiValuta(rowData.valuta)}`},
  editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_importo").length===0) {
                $('<div id="val_importo"></div>').appendTo(cellElement)
            }
            $("#val_importo").dxNumberBox({min:0,value:cellInfo.value,format:`#0.##${convertiValuta(cellInfo.data.valuta)}`, onValueChanged: function(e) {

            cellInfo.setValue(e.value)
            }})
          },
  },
        { dataField: "valuta",visible:false, alignment:allineamento,caption: "Valuta spesa",hidingPriority:5,customizeText: function (e){
          return convertiValuta(e.value)},
          editCellTemplate: function (cellElement,cellInfo) {
            if ($("#val_valuta").length===0) {
                $('<div id="val_valuta"></div>').appendTo(cellElement)
            }
            const dati_ut=[{"id":1,"name":convertiValuta(1)},{"id":2,"name":convertiValuta(2)}]
            $("#val_valuta").dxSelectBox({dataSource:dati_ut,value:cellInfo.value,displayExpr:"name",valueExpr:"id", onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            $("#val_importo").dxNumberBox("instance").option("format",`#0.##'${convertiValuta(e.value)}'`)
            }})
          },
        },
        { dataField: "testa",alignment:allineamento, caption: "Spesa a testa" ,hidingPriority:2,cellTemplate: (cellElement, cellInfo) => {
              const icon = cellInfo.value === 1 ? faCheck : faX;
              const root = ReactDOM.createRoot(cellElement.get(0));
              root.render(
                  <FontAwesomeIcon icon={icon} />
              );
            },
            editCellTemplate: function(cellElement,cellInfo) {
          if ($("#val_testa").length===0) {
                $('<div id="val_testa"></div>').appendTo(cellElement)
            }
          $("#val_testa").dxCheckBox({value:cellInfo.value, onValueChanged: function(e) {
            if (e.value)
            cellInfo.setValue(1)
            else
            cellInfo.setValue(0)
            },
            })
          },
        },
        { dataField: "importoeur",alignment:allineamento,caption: "Importo totale in euro" ,hidingPriority:1,customizeText: function (e){
          let importInt=0
          if (e.value) importInt=e.value
          return `${importInt.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}
        },
        {
            type: "buttons",
            minWidth:80,
            buttons: [
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },]}
      ],
      showBorders: true,
      scrolling: { useNative: true },
      rowAlternationEnabled: true,
      columnAutoWidth: true,
      paging: { pageSize: 50 },
      height: "auto",
      width: "auto",
      columnHidingEnabled: true,
      editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            width:"70%",
            height:"auto",
            maxHeight:"90%",
            title: `Modifica cliente`,
            showTitle: true,
          },
          form: {
            items: [
              {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                "categoria","importo","valuta","testa",
                ],
              },
            ],
          },
      },
      onInitNewRow: function (e) {
        e.data.importo=0;
        e.data.valuta=1;
        e.data.testa=0
        },
      onRowInserting: async function (e) {
            let richiesta=null
            const dati2={"excursioncostcategory":e.data.categoria,"excursionid":escursione.excursionid,"excursioncostvalue": e.data.importo,"excursioncostcurrency":e.data.valuta,"excursioncostmultiple":e.data.testa,}
             richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                valori:dati2,
                azione:'setExcursionCost'})
                $("#loadingOverlay").hide()
                if (richiesta) {
                const message = `Spesa aggiunta con successo`;

          window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerExcursions',

                },}, "success", 1000);
          const spese = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getExcursionCosts",})
          const clienti = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getExcursionCusts",})
          formattedRowsSpese=[]
          formattedRowsClienti=[]
          for (let cliente of clienti){
    if (escursione.excursionid===cliente.excursionid){
        let dati={nome:cliente.excursioncustomername,id:cliente.excursioncustomerid,
        costo:cliente.excursioncustomerpaid,pagato:cliente.excursioncustomeradvance,
        telefono:cliente.excursioncustomerphone,residenza:cliente.excursioncustomerresidence}
        formattedRowsClienti=[...formattedRowsClienti,dati]
    }
  }
  let contatore=0
  for (let spesa of spese){
    if (escursione.excursionid===spesa.excursionid){
        let dati={numero:contatore,categoria:spesa.excursioncostcategory,id:spesa.excursioncostid,
        importo:spesa.excursioncostvalue,valuta:spesa.excursioncostcurrency,
        testa:spesa.excursioncostmultiple}
        let importoEur=(spesa.excursioncostvalue)
        if (spesa.excursioncostmultiple===1)
        importoEur=importoEur*formattedRowsClienti.length
        if (spesa.excursioncostcurrency===2){
            let data=""
            data=DateTime.fromISO(escursione.data).toFormat("yyyyMMdd")
            const cambio=cambi[data]
            if (spesa.excursioncostmultiple===1)
            importoEur=(spesa.excursioncostvalue/cambio)*formattedRowsClienti.length
            else
            importoEur=(spesa.excursioncostvalue/cambio)
        }
        dati["importoeur"]=importoEur
        contatore+=1
        formattedRowsSpese=[...formattedRowsSpese,dati]
    }
  }
          $("#gridContainerSpese").dxDataGrid("instance").option("dataSource",formattedRowsSpese)

          }
          },
      onRowRemoving: async function (e) {
            const richiesta=  await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                delId:e.data.id,
                azione:'delExcursionCost',
                return_data:false})
            if (richiesta) {
                const message = `Spesa eliminata con successo`;
                window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerClienti',

                },}, "success", 1000);}
        },
      onRowUpdated: async function (e) {
            const gridElement = $("#gridContainerClienti"); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
            $("#loadingOverlay").show()
            const dati2={"excursioncostcategory":e.data.categoria,"excursioncostvalue": e.data.importo,"excursioncostcurrency":e.data.valuta,"excursioncostmultiple":e.data.testa,}
            const richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:e.data.id,
                valori:dati2,
                azione:'setExcursionCost'})
                $("#loadingOverlay").hide()
                if (richiesta) {
                const message = `Spesa modificata con successo`;

          window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerClienti',

                },}, "success", 1000);

                }
          },

    });

  }, 0);

  return div;
}
function BounceIconButton({ icon, onClick, color = "#000" }) {
  const [isClicked, setIsClicked] = useState(false);


  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 800);
    onClick();
  };

  return (
    <button
      style={{
        cursor: "pointer",
        padding: "5px",
        background: "none",
        border: "none",
        color: color,
      }}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={icon} className={isClicked ? "fa-bounce" : ""} />
    </button>
  );
}
function TabellaStorico() {
let idNoleggi=[]
    for (let i=0;i<=8;i++){
    idNoleggi=[...idNoleggi,{ID:i,name:convertiIdEscursione(i)}]
    }
    const allineamento="center"
    let eliminaNome = null;
    let aggiungiNome=null
    useEffect(() => {
        const fetchEscursioni = async () => {
           $("#gridContainerExcursions").addClass("grid-container-hidden")
           $("#loadingOverlay").show()
          const dati = await funzione_collegamento({
            userid: getUserId(),
            token: getToken(),
            filtri:{"excursionsfrom":inizioP,"excursionsto":fineP},
            azione: "getExcursions",
            })
          //const dati= await noleggi_off()
          const utenti = await funzione_collegamento({
            userid: getUserId(),
            token: getToken(),
            azione: "getUsers",
            })
          let to=DateTime.now().plus({days:1})
          to=to.toFormat("yyyyMMdd")
          let datiCambi = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getExchanges",
                filtri:{"exchangefrom":"20241001","exchangeto":to,"exchangerates":"USDEUR"+","+"USDKES"},
                })
          const conti = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getBillItems",})
        const escursioniClienti = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getExcursionCusts",})
        const escursioniCosti = await funzione_collegamento({
                userid: getUserId(),
                token: getToken(),
                azione: "getExcursionCosts",})
          //const utenti= await utenti_off()
          datiCambi=convertiCambi(datiCambi,["EURKES"])
          const formattedRows=dati.map((row, index) => ({
          id:index,
          excursionid:row.excursionid,
          data:row.excursiondatestart?convertDate(row.excursiondatestart).toISO({ includeOffset: false }):null,
          tipo:row.excursiontype,
          guadagno:guadagnoEscursione({cambio:datiCambi,partecipanti:escursioniClienti,escursione:row,spese:escursioniCosti,speseRit:false})
          }))
          $("#gridContainerExcursions").dxDataGrid({
          dataSource: formattedRows,
        columns: [
          {
            dataField: "data",
            caption: "Data",
            sortOrder: "desc",
            alignment:allineamento,
           editCellTemplate: function (cellElement,cellInfo) {
          if ($("#val_reg").length===0) {
                $('<div id="val_reg"></div>').appendTo(cellElement)
            }
            $("#val_reg").dxDateBox({type:"date",format: "dd/MM/yyyy",displayFormat :"dd/MM/yyyy",value:cellInfo.value,onValueChanged: function(e) {
            if (e.value instanceof Date) {
              cellInfo.setValue(DateTime.fromJSDate(e.value).toISO({includeOffset:false}))
            }
            else {
                cellInfo.setValue(e.value)
            }
            }})
          },
            hidingPriority: 2,
            filterOperations: ["between", "=", "<", ">"],
            calculateFilterExpression: function(filterValue, selectedFilterOperation) {
              if (!filterValue) return null;
              if (selectedFilterOperation === "between" && Array.isArray(filterValue)) {
                const isoStart = DateTime.fromJSDate(filterValue[0]).toISO({ includeOffset: false });
                const isoEnd = DateTime.fromJSDate(filterValue[1]).toISO({ includeOffset: false });
                return [
                  [this.dataField, ">=", isoStart],
                  "and",
                  [this.dataField, "<=", isoEnd]
                ];
              }
              if (selectedFilterOperation === "<") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, "<=", isoStart]
              }
              if (selectedFilterOperation === ">") {
                const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
                return [this.dataField, ">=", isoStart]
              }
              const isoStart = DateTime.fromJSDate(filterValue).toISO({ includeOffset: false });
              return [this.dataField, "=", isoStart]
            },
          customizeText: function(cellInfo) {
            if (typeof cellInfo.value==="string"){
                return DateTime.fromISO(cellInfo.value).toFormat("dd/MM/yyyy");
            }
            else {
                return DateTime.fromISO(DateTime.fromJSDate(cellInfo.value,).toISO({ includeOffset: false })).toFormat("dd/MM/yyyy");
            }
          }
          },
          { dataField: "tipo", caption: "Tipo Escursione", alignment:allineamento,hidingPriority: 5,
          customizeText: function (cellInfo) {
          return convertiIdEscursione(cellInfo.value)
          },
          editCellTemplate: function(cellElement,cellInfo) {

          if ($("#val_tipo").length===0) {
                $('<div id="val_tipo"></div>').appendTo(cellElement)
            }
          const dataTipo=idNoleggi
          $("#val_tipo").dxSelectBox({dataSource:dataTipo,valueExpr: 'ID',displayExpr: 'name',value:cellInfo.value,searchEnabled: true, onValueChanged: function(e) {
            cellInfo.setValue(e.value)
            const tipo_lez=$("#val_tipo").dxSelectBox("instance").option("value")
            },
            })
          }},
          {dataField:"guadagno",caption:"Guadagno escursione",alignment:allineamento,customizeText: function (e){
          let importoE=0
          if (e.value) importoE=e.value
          return `${importoE.toLocaleString("it-IT", { maximumFractionDigits: 2 })} €`}},
          {
            type: "buttons",
            minWidth:120,
            buttons: [
              {
                hint: "Modifica",
                icon: "none",
                onClick: function (e) {
                  e.component.editRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faPencil}
                      color="#007bff"
                      onClick={() => cellInfo.component.editRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
              {
                hint: "Elimina",
                icon: "none",
                onClick: function (e) {
                  e.component.deleteRow(e.rowIndex);
                },
                template: function (cellElement, cellInfo) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faTrashCan}
                      color="#dc3545"
                      onClick={() => cellInfo.component.deleteRow(cellInfo.rowIndex)}
                    />
                  );
                },
              },
              {
                hint: "Dettagli Escursione",
                icon: "none",
                template: function (cellElement, cellInfo,) {
                  const root = ReactDOM.createRoot(cellElement.get(0));
                  root.render(
                    <BounceIconButton
                      icon={faCircleInfo}
                      color="#03a9f4"
                      onClick={() => handleClick(cellInfo,escursioniCosti,escursioniClienti,utenti,datiCambi,conti)}
                    />
                  );
                },
              }
            ],
          },
        ],
        showBorders: true,
        scrolling:{
        useNative:true
        },
        rowAlternationEnabled: true,
        columnAutoWidth: true,
        paging: { pageSize: 50 },
        height: "100vh",
        width: "100%",
        columnHidingEnabled: true,
        searchPanel: {
          visible: true,
          width: 240,
          placeholder: 'Search...',
        },
        filterRow: {
          visible: true,
          applyFilter: 'auto',
        },
        editing: {
          mode: "popup",
          allowUpdating: true,
          allowAdding: true,
          allowDeleting: true,
          useIcons: true,
          popup: {
            title: "Modifica Escursione",
            showTitle: true,
            width:"80%",
            height:"auto",
            maxHeight:"90%",
            onShown: function(e) {
                const $content = $(e.component.content());
                $content.wrapInner('<div id="customScroll" style="height: 100%; max"></div>');
                $("#customScroll").dxScrollView({
                    useNative: true,
                    direction: "vertical",
                    showScrollbar: "onScroll"
                });
                }
            },
          form:{
            items: [
              {
                itemType: "group",
                colCount: 2,
                colSpan: 2,
                items: [
                  "data",
                  {
                    dataField: "tipo",
                    label: { text: "Tipo Escursione" }  // ← Etichetta personalizzata
                  },
                ],
              },
            ],
          },
        },
        onInitNewRow: function (e) {
        e.data.costo=0;
        e.data.pagato=0;
        e.data.sconto=0;
        },
        onRowPrepared: function (e){
        setTimeout(() => {
                $("#gridContainerExcursions").removeClass("grid-container-hidden");
                $("#loadingOverlay").hide();},500)
      if (e.rowType === "data" && e.rowElement && e.data) {
            let daSaldare=false

            for (let cliente of escursioniClienti){
                if (cliente.excursionid===e.data.excursionid){
                    if (cliente.excursioncustomerpaid!==cliente.excursioncustomeradvance){
                        daSaldare=true
                    }
                }
            }
            if (daSaldare) {
              e.rowElement.addClass("row-warning");
              e.rowElement[0].bgColor = "#ffe6e6";
            }
          }
      },
        onRowInserting: async function (e) {
            const gridElement = $("#gridContainerExcursions"); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
            const dati_n={'excursiondatestart':DateTime.fromISO(e.data.data).toFormat("yyyyMMdd"),'excursiontype':e.data.tipo,};
            const richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                valori:dati_n,
                azione:'setExcursion'})
                if (richiesta) {
                    window.location.reload()
                }

        },
        onRowRemoving: async function (e) {
            const richiesta=  await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                delId:e.data.excursionid,
                azione:'delExcursion',
                return_data:false})
            if (richiesta) {
                const message = `Escursione eliminata con successo`;
                window.DevExpress.ui.notify({message,
                position: {
                  my: 'center',
                  at: 'center',
                  of: '#gridContainerExcursions',
                },}, "success", 1000);}
        },
        onRowUpdated: async function (e) {
            const gridElement = $("#gridContainerExcursions"); // Ottieni l'intera griglia

                // Aggiungi la classe di animazione alla griglia
                gridElement.addClass("table-updated");

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => {
                    gridElement.removeClass("table-updated");
                }, 1000);
            //const nomiLista=e.data.nomi
            const dati_n={'excursiondatestart':DateTime.fromISO(e.data.data).toFormat("yyyyMMdd"),'excursiontype':e.data.tipo,};
            const richiesta = await funzione_collegamento({
               userid: getUserId(),
                token: getToken(),
                logout_on_error: true,
                setId:e.data.excursionid,
                valori:dati_n,
                azione:'setExcursion'})
                if (richiesta) {
                const message = `Escursione modificata con successo`;
                window.DevExpress.ui.notify({message,
                        position: {
                          my: 'center',
                          at: 'center',
                          of: '#gridContainerExcursions',
                        },}, "success", 1000);
                }
            },
        onCellClick: function(e) {
            if (e.event.target && e.event.target.classList.contains("dx-datagrid-adaptive-more")) {
              const masterRow = e.component.getRowElement(e.row.rowIndex);
              const $icon = masterRow.find(".dx-datagrid-adaptive-more.custom-icon-expanded");
              if (!($icon.length)) {
              const masterRow = e.component.getRowElement(e.row.rowIndex);
              const $icon = masterRow.find(".dx-datagrid-adaptive-more");
              if ($icon.length){
              $icon[0].className = "dx-datagrid-adaptive-more custom-icon-expanded";}
              }
              else
              {
              $icon[0].className = "dx-datagrid-adaptive-more";
              }}

        },
        onEditorPreparing: function(e) {
          if (e.parentType === "filterRow" && e.dataField === "data") {

            e.editorName = "dxDateBox";  // Forza DateBox come filtro
            e.editorOptions = {
              displayFormat: "dd/MM/yyyy",
              type: "date",
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);  // Applica il filtro
              }
            };
          }
          if (e.parentType === "filterRow" && e.dataField === "tipo") {
            const dataTipo=idNoleggi
            e.editorName = "dxSelectBox";  // Forza DateBox come filtro
            e.editorOptions = {
              dataSource:dataTipo,valueExpr: 'ID',displayExpr: 'name',searchEnabled: true,
              width: "100%",
              onValueChanged: function(ev) {
                e.setValue(ev.value);  // Applica il filtro
              }
            };
          }
        },

     })};



    fetchEscursioni();
    $("#infoEscursioni").dxPopup({
    width: "80%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,
    resizeEnabled: true,
    closeOnOutsideClick: true,
    showCloseButton: true,
    onShown: function(e) {
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScrollMateriale" style="height: 100%;"></div>');
    $("#customScrollMateriale").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
    }});
    $("#popupContoEdit").dxPopup({
  width: "90%",
  height: "auto",
  showTitle: true,
  title: "Gestisci conto",
  dragEnabled: false,
  hideOnOutsideClick: true
});
    $("#modificaListaNomi").dxPopup({
    width: "60%",
    height: 'auto',
    maxHeight:"90%",
    visible: false,
    dragEnabled: true,

    onShown: function(e) {
    const $content = $(e.component.content());
    $content.wrapInner('<div id="customScrollLista" style="height: 100%;"></div>');
    $("#customScrollLista").dxScrollView({
        useNative: true,
        direction: "vertical",
        showScrollbar: "onScroll"
    });
    },
    });

  }, []);
return (<div id="gridContainerExcursions" ></div>)

}
return (<div>
        <TabellaStorico/>
        <div id="infoEscursioni"></div>
        <div id="popupContoEdit"></div>
        <div id="modificaListaNomi"></div>
        <div id="loadingOverlay">
           <div className="spinner">
              <Lottie  style={{ width: "30%", height: "30%" }} animationData={animLoading} loop={true} />
           </div>
        </div>
        </div>)
}
export default EscursioniStorico